import axios from 'axios';
import { FilterOptionsParams } from 'components/RevxJobListFilter';
import { Paged } from 'domains/appDomain';
import { CanvaPublishDraft } from 'domains/gallerySkuDomain';
import {
  FlushHighResFileREsponseDTO,
  GenerateInvoiceResponse,
  JobConfig,
  JobPriceAdjust,
  JobRFQBuildQuoteItemsParams,
  JobRFQDraftShippingAdjustParams,
  JobRFQDraftShippingItemsViewer,
  JobRFQDraftViewer,
  JobRFQQuoteItemViewer,
  JobRFQSendDraftOrgItemsParams,
  JobRFQShippingAccount,
  JobRFQShippingItemViewer,
  JobRFQSupplierResponseRecordView,
  JobRFQSwitchShippingAccountParams,
  JobRFQViewer,
  JobShippingAdjust,
} from 'domains/jobconfigDomain';
import { JobFlowPayload } from 'domains/orderDomain';
import {
  JobShippingItemFulfillment,
  JobShippingItemFulfillmentUpdateRequest,
  JobShippingItemSpec,
  JobShippingSummaryItem,
  SupplierInvoiceReferenceFiles,
  SupplierInvoiceSubmitParams,
} from 'domains/workspaceDetailDomain';
import {
  JobActivity,
  JobAdjustParams,
  JobAdjustmentFee,
  JobAdjustmentParams,
  JobAdjustmentPrintingItemParams,
  JobAdjustmentSharedWithParams,
  JobAdjustmentShippingItemParams,
  JobAdjustmentViewer,
  JobCancellationParams,
  JobCancellationViewer,
  JobCount,
  JobItem,
  JobItemShipped,
  JobListFilterParams,
  JobOriginalQuote,
  JobSpecCarrierServices,
  JobStatusFilterCount,
  JobUIStatusEnum,
  JobWorkflowStatusEnum,
  PressAdjustment,
  QUOTE_TYPE_ENUM,
  JobRFMClosed,
  RFMCancelParams,
  RFMShippingOptionsParams,
  RFMDecisionEnum,
  RFMInvitation,
  RFMOffer,
  RFMOfferParams,
  RFMSupplierOrg,
  SimpleJobRevision,
  SkuAvlPresses,
  JobStatusFilterSeparateTabEnum,
  JobWorkspaceGroup,
  PDF_TEMPLATE_ENUM,
  BatchJobMergePDFParams,
  BatchJobCompleteParams,
  JobWorkspaceFilterTypeEnum,
  WorkspaceCardTypeEnum,
  JobWorkspaceDTO,
  QuoteWorkspaceDTO,
  RfmClaimWorkspaceDTO,
  RfmWorkspaceDTO,
  RfqClaimWorkspaceDTO,
  RfqWorkspaceDTO,
  AddInvoiceSharedParam,
  RFQCopyRequestDTO,
  RFQCopyResponseDTO,
} from 'domains/workspaceDomain';
import { isNumber, omit } from 'lodash-es';
import { OptionData } from 'rc-select/lib/interface';
import api from 'utils/api';
import { buildDocumentUrl } from 'utils/api';
import { JOB_MAX_QUANTITY } from 'utils/constants';
import { getEffectiveUnit } from 'utils/measurement';
import { MeasurementUnitEnum } from 'domains/measurementDomain';

export let jobListCancelToken = axios.CancelToken.source();
let jobCountCancelToken = axios.CancelToken.source();
export let jobListReqCount = 0;
export let jobCountReqCount = 0;

const workspaceService = {
  getNewJobListByStatusFilter: async ({
    statusFilter,
    page,
    size,
    rfqClosed = false,
    quoteType,
    jobOrOrderNumber,
    jobName,
    supplierName,
    requesterName,
    endOrderDate,
    startOrderDate,
    statusFilterSeparateTab,
    filterType,
    excludeProjectId,
    workflowStatus,
    jobDoc,
    startDeliveryDate,
    endDeliveryDate,
    customerOrgId,
    jobId,
    salesRep,
    rfqQueryType,
  }: {
    statusFilter?: JobUIStatusEnum | JobWorkflowStatusEnum;
    page: number;
    size: number;
    rfqClosed?: boolean;
    quoteType?: QUOTE_TYPE_ENUM;
    statusFilterSeparateTab?: JobStatusFilterSeparateTabEnum;
    filterType: JobWorkspaceFilterTypeEnum;
    excludeProjectId?: number;
  } & FilterOptionsParams) => {
    let ret: Paged<JobItem>;
    try {
      jobListReqCount = jobListReqCount + 1;
      jobListCancelToken = axios.CancelToken.source();
      ret = await api.get<Paged<JobItem>>(
        '/job-workspace/page',
        {
          statusFilter,
          rfqClosed,
          quoteType,
          size,
          page: page - 1 < 0 ? 0 : page - 1,
          jobOrOrderNumber,
          jobName,
          supplierName,
          requesterName,
          endOrderDate,
          startOrderDate,
          statusFilterSeparateTab,
          filterType,
          excludeProjectId,
          workflowStatus,
          jobDoc,
          startDeliveryDate,
          endDeliveryDate,
          customerOrgId,
          jobId,
          salesRep,
          rfqQueryType,
        },
        undefined,
        {
          cancelToken: jobListCancelToken.token,
        }
      );
    } catch (e) {
      throw e;
    } finally {
      jobListReqCount = jobListReqCount - 1;
    }
    return ret;
  },

  getWorkspacePage: async ({
    cardType,
    statusFilter,
    page,
    size,
    rfqClosed = false,
    quoteType,
    jobOrOrderNumber,
    jobName,
    supplierName,
    requesterName,
    endOrderDate,
    startOrderDate,
    statusFilterSeparateTab,
    filterType,
    excludeProjectId,
    workflowStatus,
    jobDoc,
    startDeliveryDate,
    endDeliveryDate,
  }: {
    cardType: WorkspaceCardTypeEnum;
    statusFilter?: JobUIStatusEnum;
    page: number;
    size: number;
    rfqClosed?: boolean;
    quoteType?: QUOTE_TYPE_ENUM;
    statusFilterSeparateTab?: JobStatusFilterSeparateTabEnum;
    filterType: JobWorkspaceFilterTypeEnum;
    excludeProjectId?: number;
  } & FilterOptionsParams) => {
    return api.get<
      Paged<
        | JobWorkspaceDTO
        | QuoteWorkspaceDTO
        | RfmClaimWorkspaceDTO
        | RfmWorkspaceDTO
        | RfqClaimWorkspaceDTO
        | RfqWorkspaceDTO
      >
    >('/job-workspace/page', {
      cardType,
      statusFilter,
      rfqClosed,
      quoteType,
      size,
      page: page - 1 < 0 ? 0 : page - 1,
      jobOrOrderNumber,
      jobName,
      supplierName,
      requesterName,
      endOrderDate,
      startOrderDate,
      statusFilterSeparateTab,
      filterType,
      excludeProjectId,
      workflowStatus,
      jobDoc,
      startDeliveryDate,
      endDeliveryDate,
    });
  },

  getGroupJobListByStatusFilter: async ({
    statusFilter,
    page = 1,
    size = JOB_MAX_QUANTITY,
    jobOrOrderNumber,
    jobName,
    supplierName,
    requesterName,
    endOrderDate,
    startOrderDate,
    statusFilterSeparateTab,
    filterType,
  }: {
    statusFilter?: JobUIStatusEnum | JobWorkflowStatusEnum;
    page?: number;
    size?: number;
    statusFilterSeparateTab?: JobStatusFilterSeparateTabEnum;
    filterType: JobWorkspaceFilterTypeEnum;
  } & FilterOptionsParams) => {
    let ret: Paged<JobWorkspaceGroup>;
    try {
      jobListReqCount = jobListReqCount + 1;
      jobListCancelToken = axios.CancelToken.source();
      ret = await api.get<Paged<JobWorkspaceGroup>>(
        '/job-workspace/group-page',
        {
          statusFilter,
          size,
          page: page - 1 < 0 ? 0 : page - 1,
          jobOrOrderNumber,
          jobName,
          supplierName,
          requesterName,
          endOrderDate,
          startOrderDate,
          statusFilterSeparateTab,
          filterType,
        },
        undefined,
        {
          cancelToken: jobListCancelToken.token,
        }
      );
    } catch (e) {
      throw e;
    } finally {
      jobListReqCount = jobListReqCount - 1;
    }
    return ret;
  },

  getJobCountByStatusFilter: async (statusFilters: JobUIStatusEnum[]) => {
    let ret: JobStatusFilterCount[] = [];
    try {
      if (jobCountReqCount > 0) {
        jobCountCancelToken.cancel();
      }
      jobCountReqCount = jobCountReqCount + 1;
      jobCountCancelToken = axios.CancelToken.source();

      ret = await api.get<JobStatusFilterCount[]>(
        `/job-workspace/count?statusFilters=${statusFilters.join(',')}`,
        undefined,
        undefined,
        {
          cancelToken: jobCountCancelToken.token,
        }
      );
    } catch (e) {
      throw e;
    } finally {
      jobCountReqCount = jobCountReqCount - 1;
    }
    return ret;
  },

  getJobShippingItemFulfillments: async (jobId: number) => {
    return api.get<JobShippingItemFulfillment[]>(
      `/jobs/${jobId}/shipping/fulfillment`
    );
  },

  getJobShippingItems: async (jobId: number) => {
    return api.get<JobShippingSummaryItem[]>(`/jobs/${jobId}/shipping/summary`);
  },

  getJobShippingItemSpecs: async (jobId: number) => {
    return api.get<JobShippingItemSpec[]>(`/jobs/${jobId}/shipping/spec`);
  },

  updateJobShippingItemFulfillment: async (
    jobId: number,
    fulfillmentId: number,
    updateRequest: JobShippingItemFulfillmentUpdateRequest
  ) => {
    return api.post<JobShippingItemFulfillment>(
      `/jobs/${jobId}/shipping/fulfillment/${fulfillmentId}`,
      updateRequest
    );
  },

  updateJobShippingItemFulfillmentNonstandard: async (
    jobId: number,
    fulfillmentId: number,
    params: { shippingDetails?: string; shipDate?: string }
  ) => {
    return api.post(
      `/jobs/${jobId}/shipping/fulfillment/${fulfillmentId}/shipment/nonstandard`,
      params
    );
  },

  skipForTrackNumber: async (jobId: number, fulfillmentId: number) => {
    return api.post<void>(
      `/jobs/${jobId}/shipping/fulfillment/${fulfillmentId}/skip-shipped`
    );
  },

  getJobDetail: async (jobId: number | string) => {
    return api.get<JobItem>(`/job-workspace?jobId=${jobId}`);
  },

  getJobOriginalQuote: async (jobId: number) => {
    return api.get<JobOriginalQuote>(`/jobs/${jobId}/original-quote`);
  },

  updateJob: async (jobData: Partial<JobItem>) => {
    return api.put<JobItem>(`/jobs/${jobData.id}`, jobData);
  },

  jobFlow: async (payload: JobFlowPayload) => {
    return api.get(`/jobs/flow/${payload.jobId}/${payload.event}`);
  },

  jobCount: async (payload: number[]) => {
    return api.post<JobCount[]>(`/jobs/count`, payload);
  },

  jobAllShipped: async (payload: number[]) => {
    return api.post<JobItemShipped[]>(`/jobs/all-shipped`, payload);
  },

  reorder: async (jobId: number) => {
    return api.post<JobConfig>(`/job-config/reorder/${jobId}`);
  },

  latestRfmOffersByJobIds: async (jobIds: number[]) => {
    return api.post<RFMOffer[]>(`/jobs/rfms`, jobIds);
  },

  rfmOffersByJobId: async (jobId: number) => {
    return api.get<RFMOffer[]>(`/jobs/rfms/${jobId}`);
  },

  nextRfmOffer: async (params: RFMOfferParams) => {
    return api.post<RFMOffer>(`/jobs/rfms/${params.jobId}`, params);
  },

  sendToRFM: async (jobId: number) => {
    return api.post(`/jobs/rfms/${jobId}/send`);
  },

  closedRFMs: async (page: number, size: number) => {
    return api.get<Paged<JobRFMClosed>>(
      `/jobs/rfms/closed?page=${page}&size=${size}`
    );
  },

  cancelRFM: async (jobId: number, params: RFMCancelParams) => {
    return api.post<void>(`/jobs/rfms/${jobId}/cancel`, params);
  },

  decideOnInvitation: async (
    invitationId: number,
    decision: RFMDecisionEnum
  ) => {
    return api.post<RFMInvitation>(
      `/jobs/rfms/invitations/${invitationId}/${decision}`,
      {},
      {
        useGlobalErrorHandler: false,
      }
    );
  },

  eligibleSuppliers: async (
    jobId: number,
    pressAdjustments: PressAdjustment[] | null
  ) => {
    return api.post<RFMSupplierOrg[]>(
      `/jobs/rfms/${jobId}/suppliers`,
      pressAdjustments === null ? undefined : pressAdjustments
    );
  },

  availablePresses: async (jobId: number) => {
    return api.get<SkuAvlPresses[]>(`/jobs/rfms/${jobId}/press-types`);
  },

  rfmShippingOptions: async (
    jobId: number,
    params: RFMShippingOptionsParams
  ) => {
    return api.post<JobSpecCarrierServices[]>(
      `/jobs/rfms/${jobId}/shipping-options`,
      params
    );
  },

  availableCarrierServices: async (jobId: number, pickupDate: string) => {
    return api.get<JobSpecCarrierServices[]>(
      `/jobs/rfms/${jobId}/carrier-services?pickupDate=${pickupDate}`
    );
  },

  resendInvitation: async (invitationId: number) => {
    return api.put<void>(`/jobs/rfms/invitations/${invitationId}/resend`);
  },

  getJobActivities: async (jobId: number) => {
    return api.get<Paged<JobActivity>>(`/jobs/${jobId}/activities`);
  },

  submitInvoice: async (data: SupplierInvoiceSubmitParams[]) => {
    return api.post(`/jobs/invoice/batch/submit`, data);
  },

  sendInvoiceToRevshop: async (jobId: number) => {
    return api.post(`/jobs/${jobId}/invoice/send-invoice`);
  },

  addInvoiceShare: async (invoiceShareParam: AddInvoiceSharedParam) => {
    return api.post(`/jobs/share/invoice`, invoiceShareParam);
  },

  generateInvoiceToRevshop: async (jobId: number) => {
    return api.post<GenerateInvoiceResponse>(
      `/jobs/${jobId}/invoice/generate-invoice`
    );
  },

  downloadInvoiceFile: async (fileUrl: string, fileName: string) => {
    const authToken = localStorage.getItem('Authorization') ?? '';
    return api.post(
      '/file/downloadFile',
      {
        path: fileUrl,
        fileName: fileName,
      },
      {
        responseType: 'blob',
        headers: {
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          Accept: '*/*',
          Authorization: authToken,
        },
      }
    );
  },

  checkQuickBooksLogin: async (reqestId?: string) => {
    return api.post('/payments/quickbooks/checkLogin', { requestId: reqestId });
  },

  refreshQuickBooksToken: async () => {
    return api.post('/payments/quickbooks/refresh/token', {});
  },
  saveInvoiceFile: async (
    jobId: number,
    file: SupplierInvoiceReferenceFiles
  ) => {
    return api.post<void>(`/jobs/${jobId}/invoice/file`, file);
  },

  deleteInvoiceFile: async (jobId: number, file: { path: string }) => {
    return api.delete<{ code: number; msg: string }>(
      `/jobs/${jobId}/invoice/file`,
      file
    );
  },

  supplierMarkAsPaid: async (jobId: number) => {
    return api.post(`/jobs/${jobId}/invoice/mark-as-paid`);
  },

  adjustJob: async (adjustments: JobAdjustParams) => {
    return api.put(
      `/jobs/${adjustments.jobId}/shipping-adjustment`,
      adjustments.shippingAdjustments
    );
  },

  getPdfLink: ({
    template,
    jobId,
    jobConfigId,
    serialNumber,
    // Passed by a caller inside the job wizard, which has its own unit selector: a job configured
    // in millimetres prints in millimetres, whatever the reader's own setting happens to be.
    // Everywhere else - the workspace, the order history - the reader's setting is the answer.
    measurementUnit = getEffectiveUnit(),
  }: {
    template: PDF_TEMPLATE_ENUM;
    jobId?: number;
    jobConfigId?: string;
    serialNumber?: number;
    measurementUnit?: MeasurementUnitEnum;
  }) => {
    if (isNumber(jobId) && jobId > 0) {
      // The ticket prints sizes and weights, so it has to be told which unit to print them in.
      return buildDocumentUrl(`/jobs/pdf/generate/${template}`, {
        jobId,
        measurementUnit,
      });
    }
    if (jobConfigId !== undefined) {
      return buildDocumentUrl(`/jobs/pdf/generate/${template}`, {
        jobConfigId,
        serialNumber: serialNumber || 0,
        measurementUnit,
      });
    }

    return '';
  },
  getJobRfqViewer: async (rfqId: number) => {
    return api.get<JobRFQViewer>(`/job-config/job-rfq/${rfqId}`);
  },

  getJobRfqSupplierResponseRecordViewer: async (rfqId: number) => {
    return api.get<JobRFQSupplierResponseRecordView>(`/job-config/job-rfq/supplier-response/record/${rfqId}`);
  },

  sendRfqJob: async (jobId: number, orgId: number, isConfirmation: boolean) => {
    return api.post<void>(
      `/job-config/job-rfq/${jobId}/draft/send?orgId=${orgId}&isConfirmation=${isConfirmation}`
    );
  },
  sendRfqDraft: async ({
    jobId,
    sendParams,
  }: {
    jobId: number;
    sendParams: JobRFQSendDraftOrgItemsParams[];
  }) => {
    return api.post<JobRFQViewer>(
      `/job-config/job-rfq/${jobId}/draft`,
      sendParams
    );
  },
  getRfqJobDraft: async (id: number) => {
    return api.get<JobRFQDraftViewer>(`/job-config/job-rfq/${id}/draft`);
  },
  deleteRfqJobDraft: async (jobId: number, orgId: number) => {
    return api.delete(`/job-config/job-rfq/${jobId}/draft?orgId=${orgId}`);
  },
  setRfqJobDraftViewedStatus: async ({
    jobId,
    viewedParams,
  }: {
    jobId: number;
    viewedParams: { orgId: number; qtySerialNumber: number }[];
  }) => {
    return api.post(`/job-config/job-rfq/${jobId}/draft/viewed`, viewedParams);
  },
  adjustRfqJobDraftShipping: async ({
    jobId,
    orgId,
    qtySerialNumber,
    adjustParams,
  }: {
    jobId: number;
    orgId: number;
    qtySerialNumber: number;
    adjustParams: JobRFQDraftShippingAdjustParams;
  }) => {
    return api.post<JobRFQDraftShippingItemsViewer>(
      `/job-config/job-rfq/${jobId}/draft/adjust-shipping?orgId=${orgId}&qtySerialNumber=${qtySerialNumber}`,
      adjustParams
    );
  },
  addRfqJobDraftNote: async (id: number, orgId: number, note: string) => {
    return api.post(`/job-config/job-rfq/${id}/draft/note`, { orgId, note });
  },
  sendRfqJobQuoteBuilderItems: async ({
    jobId,
    sendParams,
  }: {
    jobId: number;
    sendParams: JobRFQBuildQuoteItemsParams[];
  }) => {
    return api.post<JobRFQQuoteItemViewer[]>(
      `/job-config/job-rfq/${jobId}/build-quote`,
      sendParams
    );
  },
  getRfqJobQuoteBuilderItems: async (jobId: number) => {
    return api.get<JobRFQQuoteItemViewer[]>(
      `/job-config/job-rfq/${jobId}/build-quote`
    );
  },
  adjustRfqJobMarkup: async ({
    id,
    qtySerialNumber,
    orgId,
    sendParams,
  }: {
    id: number;
    qtySerialNumber: number;
    orgId: number;
    sendParams: {
      markupAdjust?: Partial<JobPriceAdjust>;
      shippingAdjusts?: Partial<JobShippingAdjust>[];
    };
  }) => {
    return api.post<JobRFQQuoteItemViewer[]>(
      `/job-config/job-rfq/sourcer-adjust/${id}?qtySerialNumber=${qtySerialNumber}&orgId=${orgId}`,
      sendParams
    );
  },
  adjustRfqJobSourcerPrice: async ({
    id,
    qtySerialNumber,
    orgId,
    sendParams,
  }: {
    id: number;
    qtySerialNumber: number;
    orgId: number;
    sendParams: Partial<JobPriceAdjust>;
  }) => {
    return api.post<JobRFQQuoteItemViewer[]>(
      `/job-config/job-rfq/${id}/sourcer-adjust-price?qtySerialNumber=${qtySerialNumber}&orgId=${orgId}`,
      sendParams
    );
  },
  adjustRfqJobSourcerShipping: async ({
    id,
    qtySerialNumber,
    orgId,
    sendParams,
  }: {
    id: number;
    qtySerialNumber: number;
    orgId: number;
    sendParams: JobShippingAdjust;
  }) => {
    return api.post<JobRFQShippingItemViewer>(
      `/job-config/job-rfq/sourcer-adjust-shipping/${id}?qtySerialNumber=${qtySerialNumber}&orgId=${orgId}`,
      sendParams
    );
  },
  updateRfqJobShipping: async (rfqId: number, orgId: number) => {
    return api.post(`/job-config/job-rfq/${rfqId}/update-shipping/${orgId}`);
  },

  flushHighResByJobId: async (jobId: number) => {
    return api.post<FlushHighResFileREsponseDTO>(`/api/api/canva/flush-high-res-byJobId?jobId=${jobId}`);
  },

  flushHighResByJobConfigId: async (jobConfigId: string) => {
    return api.post<FlushHighResFileREsponseDTO>(`/api/api/canva/flush-high-res-byJobConfigId?jobConfigId=${jobConfigId}`);
  },

  /**
   * Finishes a Canva publish that had no single matching SKU: the artwork was parked backend-side
   * before the redirect here, and the buyer has now picked a product in the company gallery.
   * `showOriginalError` so an expired hand-off tells the buyer to print from Canva again.
   */
  /**
   * Reads a parked Canva design. The buyer lands on the company gallery holding only the draft id,
   * so this is where the design's dimensions come from for size ranking. Dimensions arrive in
   * inches, already converted from the PDF's points.
   */
  getCanvaPublishDraft: async (draftId: string) => {
    return api.get<CanvaPublishDraft>(
      `/api/api/canva/publish-draft/${encodeURIComponent(draftId)}`
    );
  },

  publishCanvaDraft: async (params: {
    draftId: string;
    skuId: number;
    /**
     * The hand-off named the products this buyer chose from (?skuTags=). Turns off the
     * size-match reasoning server-side: Canva already decided what was on offer.
     */
    skuFromNamedSet?: boolean;
  }) => {
    return api.post<{ jobConfigId: string }>(
      `/api/api/canva/publish-from-draft`,
      params,
      {},
      { showOriginalError: true }
    );
  },

  // Kicks off the Canva OAuth connect flow. Returns a map that contains an
  // `authorizeUrl` when the user needs to (re)authorize.
  canvaConnectStart: async () => {
    return api.post<Record<string, string>>(
      `/api/oauth/canva/connect/start`
    );
  },

  addRfqJobToCart: async ({
    id,
    qtySerialNumber,
    orgId,
  }: {
    id: number;
    qtySerialNumber: number;
    orgId: number;
  }) => {
    return api.post<void>(
      `/job-config/job-rfq/${id}/add-to-cart?orgId=${orgId}&qtySerialNumber=${qtySerialNumber}`
    );
  },
  editRfqJobName: async ({
    projectName,
    id,
  }: {
    projectName: string;
    id: number;
  }) => {
    return api.put<JobItem>(`/job-config/job-rfq/${id}`, { projectName });
  },
  closeRfqJob: async (id: number) => {
    return api.post<void>(`/job-config/job-rfq/${id}/close`);
  },
  closeAndCopyRfqJob: async (id: number) => {
    return api.post<JobItem>(`/job-config/job-rfq/${id}/copy-and-close`);
  },

  copyRfq: async (payload: RFQCopyRequestDTO) => {
    return api.post<RFQCopyResponseDTO>(`/job-config/job-rfq/copy`, payload);
  },
  switchRfqJobShippingAccount: async (
    params: JobRFQSwitchShippingAccountParams
  ) => {
    return api.get<JobRFQShippingAccount[]>(
      `/job-config/job-rfq/${params.rfqId}/switch-shipping-account`,
      { ...omit(params, 'rfqId') }
    );
  },
  shareRfqJobQuote: async ({
    rfqId,
    email,
    firstName,
    lastName,
    serialNumbers,
  }: {
    rfqId: number;
    email: string;
    firstName: string;
    lastName: string;
    serialNumbers?: Array<{ orgId: number; qtySerialNumber: number }>;
  }) => {
    return api.post(`/job-config/job-rfq/${rfqId}/quote-share`, {
      email,
      firstName,
      lastName,
      serialNumbers,
    });
  },
  viewRfqJobQuote: ({ id }: { id: number }) => {
    return buildDocumentUrl(`/job-config/job-rfq/${id}/quote-view`, {
      measurementUnit: getEffectiveUnit(),
    });
  },
  rfqJobReturnQuote: (id: number) => {
    return api.post(`/job-config/job-rfq/${id}/return-quote`);
  },
  jobsAdjustmentsAll: (jobId: string) => {
    return api.get<JobAdjustmentViewer[]>(`/jobs/${jobId}/adjustments/all`);
  },
  getJobAdjustmentById: (jobId: string, adjustmentId: number) => {
    return api.get<JobAdjustmentViewer[]>(
      `/jobs/${jobId}/adjustments/getByAdjustmentId/${adjustmentId}`
    );
  },
  getJobCancellations: (jobId: string) => {
    return api.get<JobCancellationViewer>(`/jobs/${jobId}/cancellations`);
  },
  createJobCancellations: (jobId: string) => {
    return api.post<JobCancellationViewer>(`/jobs/${jobId}/cancellations`);
  },
  updateJobCancellations: (
    jobId: string,
    id: number,
    data: Partial<JobCancellationParams>
  ) => {
    return api.put<JobCancellationViewer>(
      `/jobs/${jobId}/cancellations/${id}`,
      data
    );
  },
  jobAdjustments: async (jobId: number) => {
    return api.post<JobAdjustmentViewer>(`/jobs/${jobId}/adjustments`);
  },
  updateJobAdjustments: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentParams
  ) => {
    return api.put<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}`,
      params
    );
  },
  jobAdjustmentPrinting: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentPrintingItemParams
  ) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustment/${jobAdjustmentId}/printing-items`,
      params
    );
  },
  deleteJobAdjustmentPrinting: async (
    jobId: number,
    jobAdjustmentId: number,
    itemId: number
  ) => {
    return api.delete<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustment/${jobAdjustmentId}/printing-items/${itemId}`
    );
  },
  updateJobAdjustmentPrinting: async (
    jobId: number,
    jobAdjustmentId: number,
    itemId: number,
    params: JobAdjustmentPrintingItemParams
  ) => {
    return api.put<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustment/${jobAdjustmentId}/printing-items/${itemId}`,
      params
    );
  },
  addJobAdjustmentFeeRow: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentFee
  ) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/fees`,
      params
    );
  },
  updateJobAdjustmentFeeRow: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentFee
  ) => {
    return api.put<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/fees`,
      params
    );
  },
  deleteJobAdjustmentFeeRow: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentFee
  ) => {
    return api.delete<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/fees`,
      params
    );
  },
  jobAdjustmentCopyForEdit: async (jobId: number, jobAdjustmentId: number) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/copy-for-edit`,
      {},
      { useGlobalErrorHandler: false }
    );
  },
  submitJobAdjustment: async (
    jobId: number,
    jobAdjustmentId: number,
    supplierContactsIds: number[]
  ) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/submit`,
      supplierContactsIds
    );
  },

  submitJobAdjustmentAll: async (
    jobId: number,
    supplierContactsIds: number[]
  ) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/submit`,
      supplierContactsIds
    );
  },
  approveJobAdjustment: async (jobId: number, jobAdjustmentId: number) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/approve`
    );
  },
  acceptJobAdjustments: async (jobId: number, jobAdjustmentId: number) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/accept`
    );
  },
  submitJobAdjustments: async (jobId: number, jobAdjustmentId: number) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/cancellations/${jobAdjustmentId}/submit`
    );
  },
  cancelJobCancellations: async (jobId: number, jobAdjustmentId: number) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/cancellations/${jobAdjustmentId}/cancel`
    );
  },
  updateJobAdjustmentShippingItems: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentShippingItemParams
  ) => {
    return api.put<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/shipping-items`,
      params
    );
  },
  updateJobAdjustmentShippingReadyDate: async (
    jobId: number,
    jobAdjustmentId: number,
    readyDate: string
  ) => {
    return api.put<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/shipping-items/update-ready-date?readyDate=${readyDate}`
    );
  },
  jobAdjustmentShareQuote: async (
    jobId: number,
    jobAdjustmentId: number,
    params: JobAdjustmentSharedWithParams
  ) => {
    return api.post(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/shared-with`,
      params
    );
  },
  cancelJobAdjustment: async (jobId: number, jobAdjustmentId: number) => {
    return api.post<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/cancel`
    );
  },
  cancelJobAdjustmentAll: async (jobId: number, jobAdjustmentId: number) => {
    return api.delete<JobAdjustmentViewer>(
      `/jobs/${jobId}/adjustments/${jobAdjustmentId}/cancel`
    );
  },

  forceCancelJobAdjustment: async (jobId: number) => {
    return api.delete<JobAdjustmentViewer>(`/jobs/${jobId}/adjustments/cancel`);
  },
  getJobListFilterJobNumber: async (params: JobListFilterParams) => {
    return api.get<OptionData[]>(
      '/job-workspace/filter-data/job-or-order-number',
      params
    );
  },
  getJobListFilterJobName: async (params: JobListFilterParams) => {
    return api.get<OptionData[]>('/job-workspace/filter-data/job-name', params);
  },
  getJobListFilterSupplierName: async (params: JobListFilterParams) => {
    return api.get<OptionData[]>(
      '/job-workspace/filter-data/supplier-name',
      params
    );
  },
  getJobListFilterRequesterName: async (params: JobListFilterParams) => {
    return api.get<OptionData[]>(
      '/job-workspace/filter-data/requester-name',
      params
    );
  },
  getJobListFilterStatus: async (params: JobListFilterParams) => {
    return api.get<OptionData[]>(
      '/job-workspace/filter-data/workflow-status',
      params
    );
  },

  getJobRevisionList: async (jobId: number) => {
    return api.get<SimpleJobRevision[]>(`/job-revision/list?jobId=${jobId}`);
  },
  addJobRevision: async (jobId: number) => {
    return api.post<SimpleJobRevision[]>(`/job-revision/add?jobId=${jobId}`);
  },
  batchJobMarkAsPaid: async (jobIds: number[]) => {
    return api.post(`/jobs/batch/invoice/mark-as-paid`, jobIds);
  },
  batchJobArchive: async (jobIds: string) => {
    return api.post<void>(`/jobs/batch/archive?jobIds=${jobIds}`);
  },
  batchJobRollbackArchive: async (jobIds: string) => {
    return api.post<void>(`/jobs/batch/rollback-archive?jobIds=${jobIds}`);
  },
  batchJobDownloadPDF: ({
    jobIds,
    mergeType,
    template,
  }: BatchJobMergePDFParams) => {
    return buildDocumentUrl(`/jobs/pdf/batch-generate`, {
      jobIds: String(jobIds),
      mergeType,
      template,
      measurementUnit: getEffectiveUnit(),
    });
  },
  batchJobComplete: async (params: BatchJobCompleteParams) => {
    return api.post(`/jobs/batch/invoice/send-invoice`, params);
  },
  batchJobSkipShipped: async (jobIds: number[]) => {
    return api.post(`/jobs/batch/skip-shipped`, jobIds);
  },
};

export default workspaceService;
